export const CARD_PAYMENT_REFUSED_GIF_URL =
  "https://chatbot-cdn.mycon.com.br/consorcio-digital/cards/assets/cartao-recusado.gif";

export const CARD_PAYMENT_APPROVED_GIF_URL =
  "https://chatbot-cdn.mycon.com.br/consorcio-digital/cards/assets/cartao-aprovado.gif";

export const CARD_PAYMENT_REFUSED_PLACEHOLDER = "[PAGAMENTO RECUSADO]";
export const CARD_PAYMENT_APPROVED_PLACEHOLDER = "[PAGAMENTO APROVADO]";
